import Vue from 'vue';
import Storage from 'vue-ls';

Vue.use(Storage, {
    namespace: '',
    name: 'ls',
    storage: 'local',
});
